<template>
  <portlet
      :icon="'fal fa-cog portlet-icon'"
      :title="$t('ui.options')"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20"
  >
    <template slot="actionsBlock">
      <div v-if="showCloseButton" @click="$emit('closePortletClicked')" class="toggle-filter-btn-clos">
        <div class="toggle-button">
          <!--          <i class="fas fa-angle-right toggle-icon"></i>-->
          <i class="fas fa-times" style="cursor: pointer"></i>
        </div>
      </div>
    </template>
    <template slot="portletBody">

      <div class="row settings-row">

        <!--        <div class="col-12">-->
        <!--          <button @click="resetSelectedFocusDate()" style="height: 100%; width: 100%"-->
        <!--                  class="btn-wrap btn btn-outline-primary">-->
        <!--            {{ $t('oeeAnalytics.oeeCharts.resetSelectedFocusDate') }}-->
        <!--          </button>-->
        <!--        </div>-->
        <div class="col-12">


        </div>
        <div class="col-12">

        </div>
      </div>

    </template>
  </portlet>
</template>

<script>
export default {
  name: "OptionsMenu",
  props: ['showCloseButton'],
}
</script>

<style  lang="scss" scoped>


.toggle-filter-btn-close {
  z-index: 999;
  cursor: pointer;
  font-size: 2.5rem;
  color: #00c9ff;
  position: fixed;
  right: 290px;
  top: calc(50% - 3rem);
  background-color: #ffffff;
  border: 1px solid #00c9ff;
  width: 4rem;
  height: 4rem;
  display: grid;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  justify-items: center;
  -webkit-animation: swirl-in-fwd 0.1s ease-out 200ms both;
  animation: swirl-in-fwd 0.1s ease-out 200ms both;
  border-radius: 100px;
}

/* ----------------------------------------------
 * Generated by Animista on 2022-3-15 15:29:0
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation swirl-in-fwd
 * ----------------------------------------
 */
@-webkit-keyframes swirl-in-fwd {
  0% {
    -webkit-transform: rotate(-540deg) scale(0);
    transform: rotate(-540deg) scale(0);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotate(0) scale(1);
    transform: rotate(0) scale(1);
    opacity: 1;
  }
}

@keyframes swirl-in-fwd {
  0% {
    -webkit-transform: rotate(-540deg) scale(0);
    transform: rotate(-540deg) scale(0);
    opacity: 0;
  }
  100% {
    -webkit-transform: rotate(0) scale(1);
    transform: rotate(0) scale(1);
    opacity: 1;
  }
}


</style>